export default __webpack_public_path__ + "static/media/checkCircle.b90a8795.svg";